// Insights/index.js
import NewAdminContainer from './NewAdminContainer';

export default { NewAdminContainer };
